export default "__VITE_ASSET__DIIbKVFE__"